'use client';

import { FeaturedBookmakerCard } from '@/components/bookmakers/FeaturedBookmakerCard';
import { Button } from '@/components/button';
import type { BookmakersResponse } from '@/strapi/bookmakers';
import { cn } from '@/utils/cn';

interface FeaturedBookmakersProps {
  featuredBookmakers: BookmakersResponse;
  className?: string;
}

export const FeaturedBookmakers = ({
  className,
  featuredBookmakers,
}: FeaturedBookmakersProps) => {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 rounded-lg bg-medium-gray p-4',
        className
      )}
    >
      <div className="flex flex-row items-center justify-between">
        <p className="font-bold text-base">Featured Bookmakers</p>
        <p className="hidden font-semibold text-xs md:block">
          Reviewed by the GOCORE.GG team.
        </p>
      </div>
      <div className="flex flex-col gap-3">
        {featuredBookmakers.data
          .sort(
            (a, b) =>
              a.attributes.FeaturedPosition - b.attributes.FeaturedPosition
          )
          .slice(0, 5)
          .map((item) => (
            <FeaturedBookmakerCard data={item} key={item.id} />
          ))}
      </div>
      <div className="flex md:justify-end">
        <Button
          as="link"
          className="w-full md:w-auto"
          href="/hub"
          size="lg"
          variant="outline"
        >
          Compare Bookmakers
        </Button>
      </div>
    </div>
  );
};
